import { connect, mapProps } from '@formily/react'
import { isDate, isNil } from 'lodash'
import { DateTimePicker } from '../ui/time-picker'

export const FormilyDateTimePicker = connect(
  DateTimePicker,
  mapProps((props) => {
    return {
      ...props,
      value: !isNil(props.value)
        ? isDate(props.value)
          ? props.value
          : new Date(props.value)
        : undefined,
    }
  }),
)
